import { useCallback, useEffect, useState } from 'react';
import useAuthentication from '~/hooks/use-authentication';
import api from '~/lib/api';

function useIpxProviders() {
  const { isLoggedIn, isGod, isDemiGod } = useAuthentication();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const isAllowedAccess = isGod || isDemiGod;

  const get = useCallback(async () => {
    if (!isLoggedIn) return;
    if (!isAllowedAccess) return;
    try {
      const response = await api.get('/ipx-providers');
      setData(response.data);
      setLoading(false);
    } catch (e) {
      setError(e);
      setLoading(false);
    }
  }, [isLoggedIn, isAllowedAccess]);

  useEffect(() => {
    setLoading(true);
    get();
  }, [get]);

  return {
    loading,
    error,
    data,
  };
}

export default useIpxProviders;
